import { useState } from 'react';
import FrameTab from './design/FrameTab';
import LogoTab from './design/LogoTab';
import ShapeTab from './design/ShapeTab';

const TABS = [
  { id: 'shape', label: 'Shape' },
  { id: 'frame', label: 'Frame' },
  { id: 'logo', label: 'Logo' },
];

export default function DesignPanel({ style, updateStyle, embedded = false }) {
  const [activeTab, setActiveTab] = useState('shape');

  return (
    <div className={embedded ? '' : 'mt-8 border-t border-slate-100 pt-8'}>
      {!embedded && (
        <>
          <h3 className="mb-1 text-base font-semibold text-slate-900">
            Design your QR code
          </h3>
          <p className="mb-4 text-sm text-slate-500">
            Customize shape, frame, and logo — preview updates instantly.
          </p>
        </>
      )}

      <div className="mb-5 flex gap-1 rounded-lg bg-slate-100 p-1">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition ${
              activeTab === tab.id
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'shape' && <ShapeTab style={style} updateStyle={updateStyle} />}
      {activeTab === 'frame' && <FrameTab style={style} updateStyle={updateStyle} />}
      {activeTab === 'logo' && <LogoTab style={style} updateStyle={updateStyle} />}
    </div>
  );
}
